import { Box, BoxProps, Icon, Text, TextProps } from '@jfs/ui-new'
import { getRandomAlphaNumString } from '@jfs/utils'
import { Children, FC, ReactElement } from 'react'
import { Colors, FontFamily, FontWeight } from '../../util/util'

export interface BreadcrumbProps {
  hide?: boolean
  crumbs: any[]
  navigate: any
}

const styles = {
  container: { flexDirection: 'row', alignItems: 'center', ph: 5, pv: 10, justifyContent: 'flex-start' } as BoxProps,
  lastNodeStyle: {
    color: Colors.HELPER_TEXT,
    fontSize: 12,
    fontWeight: FontWeight.MEDIUM,
    fontFamily: FontFamily.MEDIUM,
    marginStart: 4,
  } as TextProps,
  breadCrumbStyle: {
    color: 'BLUE',
    fontSize: 12,
    fontWeight: FontWeight.MEDIUM,
    fontFamily: FontFamily.MEDIUM,
    marginEnd: 4,
  } as TextProps,
}

const FrontIcon = (): ReactElement => {
  return <Icon id={'ARROW_RIGHT'} color={Colors.HELPER_TEXT} size={16} key={getRandomAlphaNumString(3)} />
}

const NativeBreadcrumb: FC<BreadcrumbProps> = ({ hide = false, crumbs, navigate }: BreadcrumbProps) => {
  if (hide) {
    return null
  }

  const crumbChilds = crumbs.map(({ to, label, params }, index) => {
    if (index === crumbs.length - 1) {
      return (
        <Text {...styles.lastNodeStyle} key={getRandomAlphaNumString(3)}>
          {label}
        </Text>
      )
    }

    return (
      <Box
        disabled={to === undefined}
        onPress={() => to && navigate(to, params)}
        testID="breadcrumb"
        underlayColor={'TRANSPARENT'}
        key={getRandomAlphaNumString(2)}>
        <Text {...styles.breadCrumbStyle}>{label}</Text>
      </Box>
    )
  })

  const bChildrens = Children.toArray(crumbChilds)

  const lastIndex = bChildrens.length - 1

  const newChildrens = bChildrens?.reduce((acc: any[] = [], child, index) => {
    const notLast = index < lastIndex
    if (notLast) {
      acc.push(child, FrontIcon())
    } else {
      acc.push(child)
    }
    return acc
  }, [])

  return <Box {...styles.container}>{newChildrens}</Box>
}

export default NativeBreadcrumb
